// src/pages/Toolkits.js
import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import OuterHeader from "../components/OuterHeader";
import Footer from "../components/Footer";

const TOOLKITS = [
  {
    title: "Emotional First-Aid",
    description: "Fast relief for overwhelm, panic, stress.",
    slug: "emotional-first-aid",
    emoji: "🌾",
    meta: "2 minutes • reset",
  },
  {
    title: "Loneliness Toolkit",
    description: "For the days that feel a little too quiet.",
    slug: "loneliness",
    emoji: "💜",
    meta: "7 minutes • soften",
  },
  {
    title: "Daily Resilience Routine",
    description: "Small rituals that build steady emotional strength.",
    slug: "resilience-routine",
    emoji: "🌤️",
    meta: "5 minutes • strengthen",
  },
  {
    title: "Winter Wellness Toolkit",
    description: "Gentle support for seasonal dips and low-energy days.",
    slug: "winter-wellness",
    emoji: "❄️",
    meta: "6 minutes • warm up",
  },
  {
    title: "Rural Wellness Toolkit",
    description: "Practical, grounded care, built for rural realities.",
     slug: "rural-wellness",
    // slug:  "wellness-on-wheels",
    emoji: "🚐",
    meta: "Created in partnership with Wellness on Wheels",
    // type: "experience",
    // badge: "Partner",
  },
  {
    slug: "navigating-layoff",
    title: "Navigating a Layoff",
    emoji: "🧭",
    description: "Steady emotional + practical support after job loss.",
    // meta: "Life event • stabilize",
    // badge: "Life Event",
  },
];

export default function Toolkits() {
  const [showTip, setShowTip] = useState(false);

  const isMobile =
    typeof window !== "undefined" ? window.innerWidth < 920 : false;

  const styles = useMemo(
    () => ({
      page: {
        minHeight: "calc(100vh - 120px)",
        // background:
        //   "radial-gradient(900px 420px at 15% 10%, rgba(255, 150, 120, 0.14), rgba(255,255,255,0) 60%)," +
        //   "radial-gradient(760px 360px at 85% 18%, rgba(182, 130, 205, 0.10), rgba(255,255,255,0) 62%)," +
        //   "linear-gradient(180deg, #ffffff 0%, #fffaf8 55%, #ffffff 100%)",
          background: "var(--tk-page-bg)",

      },

      container: {
        maxWidth: 1120,
        margin: "0 auto",
        padding: "64px 22px 90px",
      },

      hero: {
        padding: "28px 28px",
        borderRadius: 26,
        border: "1px solid rgba(240, 200, 190, 0.70)",
        background:
          "linear-gradient(135deg, rgba(255, 240, 236, 0.9), rgba(255, 255, 255, 0.65))",
        boxShadow: "0 18px 55px rgba(19, 17, 26, 0.06)",
        backdropFilter: "blur(10px)",
      },

      heroTitle: {
        margin: 0,
        fontSize: 44,
        lineHeight: 1.08,
        letterSpacing: "-0.02em",
        color: "#F16A37",
        fontWeight: 780,
      },

      heroSub: {
        marginTop: 14,
        marginBottom: 0,
        maxWidth: 720,
        fontSize: 16.5,
        lineHeight: 1.55,
        color: "rgba(20, 18, 24, 0.72)",
      },

      heroPillsRow: {
        marginTop: 18,
        display: "flex",
        flexWrap: "wrap",
        gap: 10,
      },

      chip: {
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        padding: "9px 12px",
        borderRadius: 999,
        border: "1px solid rgba(240, 200, 190, 0.45)",
        background: "rgba(255,255,255,0.32)",
        fontSize: 13,
        color: "rgba(20, 18, 24, 0.68)",
        userSelect: "none",
        cursor: "default",
      },

      howWrap: {
        position: "relative",
        marginTop: 14,
        display: "inline-block",
      },

      howLink: {
        fontSize: 13,
        color: "rgba(20, 18, 24, 0.50)",
        cursor: "pointer",
        borderBottom: "1px dotted rgba(20, 18, 24, 0.25)",
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
      },

      tooltip: {
        position: "absolute",
        top: 26,
        left: 0,
        width: 340,
        maxWidth: "calc(100vw - 72px)",
        padding: "12px 14px",
        borderRadius: 14,
        background: "rgba(255,255,255,0.96)",
        border: "1px solid rgba(240, 200, 190, 0.6)",
        boxShadow: "0 18px 45px rgba(0,0,0,0.08)",
        fontSize: 13,
        lineHeight: 1.5,
        color: "rgba(20,18,24,0.72)",
        opacity: showTip ? 1 : 0,
        transform: showTip ? "translateY(0px)" : "translateY(-6px)",
        transition: "all 160ms ease",
        pointerEvents: showTip ? "auto" : "none",
        zIndex: 20,
      },

      gridWrap: {
        marginTop: 34,
      },

      sectionTitleRow: {
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "space-between",
        gap: 16,
        marginBottom: 18,
      },

      sectionTitle: {
        margin: 0,
        fontSize: 18,
        fontWeight: 800,
        color: "#141218",
        letterSpacing: "-0.01em",
      },

      sectionHint: {
        margin: 0,
        fontSize: 13.5,
        color: "rgba(20, 18, 24, 0.60)",
      },

      grid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(270px, 1fr))",
        gap: 18,
      },

      card: {
        position: "relative",
        padding: "22px 20px",
        borderRadius: 22,
        border: "1px solid rgba(240, 200, 190, 0.72)",
        background:
          "linear-gradient(135deg, rgba(255,255,255,0.78), rgba(255, 248, 246, 0.62))",
        boxShadow: "0 14px 45px rgba(19, 17, 26, 0.05)",
        backdropFilter: "blur(10px)",
        transition:
          "transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease",
        cursor: "pointer",
        overflow: "hidden",
      },

      cardTopRow: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 12,
      },

      emojiBubble: {
        width: 44,
        height: 44,
        borderRadius: 14,
        display: "grid",
        placeItems: "center",
        fontSize: 22,
        border: "1px solid rgba(240, 200, 190, 0.85)",
        background: "rgba(255,255,255,0.78)",
        boxShadow: "0 10px 24px rgba(19, 17, 26, 0.05)",
      },

      badge: {
        fontSize: 12,
        padding: "7px 10px",
        borderRadius: 999,
        border: "1px solid rgba(240, 200, 190, 0.9)",
        background: "rgba(255,255,255,0.75)",
        color: "rgba(20, 18, 24, 0.70)",
        whiteSpace: "nowrap",
      },

      cardTitle: {
        margin: "14px 0 8px",
        fontSize: 18,
        fontWeight: 780,
        letterSpacing: "-0.01em",
        color: "#141218",
      },

      cardDesc: {
        margin: 0,
        fontSize: 14.5,
        lineHeight: 1.55,
        color: "rgba(20, 18, 24, 0.68)",
      },

      cardMetaRow: {
        marginTop: 14,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
      },

      meta: {
        fontSize: 12.5,
        color: "rgba(20, 18, 24, 0.55)",
      },

      cta: {
        fontSize: 13.5,
        fontWeight: 800,
        color: "#D56743",
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
      },

      arrow: {
        display: "inline-block",
        transform: "translateY(1px)",
      },
    }),
    [showTip]
  );

  return (
    <>
      <OuterHeader />

      <div style={styles.page}>
        <div style={styles.container}>
          {/* HERO */}
          <div style={styles.hero}>
            <h1 style={styles.heroTitle}>Toolkits for real life.</h1>

            <p style={styles.heroSub}>
              Quick, compassionate support designed for communities, workplaces,
              students, and individuals seeking emotional grounding.
            </p>

            {/* <div style={styles.heroPillsRow}>
              <div style={styles.chip}>🌿 low effort</div>
              <div style={styles.chip}>🕊️ gentle tone</div>
              <div style={styles.chip}>⏱️ minutes, not hours</div>
            </div> */}

            {/* Subtle how-it-works link (no icon) */}
            <div
              style={styles.howWrap}
              onMouseEnter={() => !isMobile && setShowTip(true)}
              onMouseLeave={() => !isMobile && setShowTip(false)}
            >
              <span
                style={styles.howLink}
                onClick={() => isMobile && setShowTip((v) => !v)}
              >
                How it works
              </span>

              <div style={styles.tooltip}>
                Pick a toolkit → open a short sequence → leave with a calmer
                nervous system and a clearer next step.
              </div>
            </div>
          </div>

          {/* GRID */}
          <div style={styles.gridWrap}>
            <div style={styles.sectionTitleRow}>
              <h2 style={styles.sectionTitle}>Explore</h2>
              <p style={styles.sectionHint}>Choose what matches your day.</p>
            </div>

            <div style={styles.grid}>
              {TOOLKITS.map((t) => (
                <Link
                  key={t.slug}
                 to={`/toolkits/${t.slug}`}
                //   to={
                //     t.type === "experience"
                //       ? `/experiences/${t.slug}`
                //       : `/toolkits/${t.slug}`
                //   }
                  style={{ textDecoration: "none" }}
                >
                  <div
                    style={styles.card}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-4px)";
                      e.currentTarget.style.boxShadow =
                        "0 22px 70px rgba(19, 17, 26, 0.09)";
                      e.currentTarget.style.borderColor =
                        "rgba(230, 170, 155, 0.95)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0px)";
                      e.currentTarget.style.boxShadow = styles.card.boxShadow;
                      e.currentTarget.style.borderColor =
                        "rgba(240, 200, 190, 0.72)";
                    }}
                  >
                    <div style={styles.cardTopRow}>
                      <div style={styles.emojiBubble}>{t.emoji}</div>
                      {t.badge ? <div style={styles.badge}>{t.badge}</div> : null}
                    </div>

                    <div style={styles.cardTitle}>{t.title}</div>
                    <p style={styles.cardDesc}>{t.description}</p>

                    <div style={styles.cardMetaRow}>
                      <div style={styles.meta}>{t.meta || ""}</div>
                      <div style={styles.cta}>
                        Open <span style={styles.arrow}>→</span>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}
